import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'DNA Specialty',   //theme name
        true,       //loadingSpinner
        true,      //fixedHeader
        true,      //fixedSidenav
        false,      //fixedFooter
        true,       //sidenavIsOpened
        true,       //sidenavIsPinned
        'vertical', //horizontal , vertical
        'default',  //default, compact, mini
        'dna-light',   //tema DNA Direct (espelho do specialty-sso-web)
        false       // true = rtl, false = ltr
    )
}

